export const config = {
  apiKey: "AIzaSyCTU9shvfjJg24qhdxWCMPSKus35NEmbQI",
  authDomain: "aaronserver.firebaseapp.com",
  projectId: "aaronserver",
  storageBucket: "aaronserver.appspot.com",
  messagingSenderId: "411897028980",
  appId: "1:411897028980:web:71de8bfb0526f19e40cc21",
  measurementId: "G-0NSB6LB2QK"
};


// WEBPACK FOOTER //
// ./src/firebase/config.js